module.exports = __webpack_public_path__ + "img/card-img_2(375).b8d16b93.png";